module.exports = __webpack_public_path__ + "assets/img/prev_month.f16cd25c.svg";